module.exports = __webpack_public_path__ + "img/car_00023.67c31853.jpg";